import React, { useEffect, useRef, useState } from 'react';
import { FaChevronLeft, FaChevronRight } from 'react-icons/fa';
import axios from 'axios';
import './Slider.css';
import { useTranslation } from 'react-i18next';

const Slider = ({ onTopicSelect }) => {
    const [topics, setTopics] = useState([]);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(null);
    const scrollRef = useRef(null);
    const [popupContent, setPopupContent] = useState(null);
    const [popupPosition, setPopupPosition] = useState({ x: 0, y: 0 });
       const { t } = useTranslation();

    useEffect(() => {
        fetchRandomQuestions();
    }, []);

    const fetchRandomQuestions = async () => {
        try {
            const response = await axios.get('https://ai.kesifaraci.com/service/prompts');
            if (response.data.result) {
                const questions = response.data.data.map(q => q.text);
                setTopics(questions);
            } else {
                setError('Veri alınamadı');
            }
        } catch (error) {
            setError('Örnek sorular yüklenirken bir hata oluştu');
            console.error('Error fetching example questions:', error);
        } finally {
            setLoading(false);
        }
    };

    const scrollLeft = () => {
        if (scrollRef.current) {
            if (scrollRef.current.scrollLeft <= 0) {
                scrollRef.current.scrollLeft = scrollRef.current.scrollWidth / 2;
            }
            scrollRef.current.scrollBy({ left: -300, behavior: 'smooth' });
        }
    };

    const scrollRight = () => {
        if (scrollRef.current) {
            if (scrollRef.current.scrollLeft + scrollRef.current.offsetWidth >= scrollRef.current.scrollWidth) {
                scrollRef.current.scrollLeft = scrollRef.current.scrollWidth / 2 - scrollRef.current.offsetWidth;
            }
            scrollRef.current.scrollBy({ left: 300, behavior: 'smooth' });
        }
    };

    useEffect(() => {
        if (scrollRef.current) {
            scrollRef.current.scrollLeft = scrollRef.current.scrollWidth / 4;
        }
    }, [topics]);

    const handleTopicClick = (topic) => {
        if (onTopicSelect) {
            onTopicSelect(topic);
        }
    };

    const handleMouseEnter = (e, topic) => {
        const rect = e.currentTarget.getBoundingClientRect();
        setPopupPosition({
            x: rect.left + rect.width / 2,
            y: rect.top
        });
        setPopupContent(topic);
    };

    const handleMouseLeave = () => {
        setPopupContent(null);
    };

    if (loading) {
        return <div className="loading">Yükleniyor...</div>;
    }

    if (error) {
        return <div className="error">{error}</div>;
    }

    if (!topics || topics.length === 0) {
        return <div className="no-data">Henüz örnek soru bulunmuyor...</div>;
    }

    const clonedTopics = [...topics, ...topics];

    return (
        <div className="topics-carousel">
            <button
                onClick={scrollLeft}
                className="carousel-button carousel-button-left"
                aria-label="Sola kaydır"
            >
                <FaChevronLeft />
            </button>

            <div className="topics" ref={scrollRef}>
                {clonedTopics.map((topic, index) => (
                    <button
                        key={index}
                        onClick={() => handleTopicClick(t(topic))}
                        onMouseEnter={(e) => handleMouseEnter(e, t(topic))}
                        onMouseLeave={handleMouseLeave}
                        className="topic-card"
                        tabIndex={0}
                    >
                        <p> {t(topic)}</p>
                    </button>
                ))}
            </div>

            <button
                onClick={scrollRight}
                className="carousel-button carousel-button-right"
                aria-label="Sağa kaydır"
            >
                <FaChevronRight />
            </button>

            {popupContent && (
                <div
                    className="popup"
                    style={{
                        position: 'fixed',
                        left: `${popupPosition.x}px`,
                        top: `${popupPosition.y - 10}px`,
                        transform: 'translate(-50%, -100%)'
                    }}
                >
                    <div className="popup-content">
                        {popupContent}
                    </div>
                </div>
            )}
        </div>
    );
};

export default Slider;